import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useOutbrainBusinessManagerStore = defineStore({
  id: 'outbrainBusinessManagerStore',
  state: () => ({
    outbrainBusinessManagers: [],
    outbrainBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getOutbrainBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.outbrainBusinessManagersLoading = true

      try {
        const {data} = await axios.get('outbrain/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.outbrainBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.outbrainBusinessManagersLoading = false
      }
    },
  },
})
